import * as z from 'zod';

import { formatPhoneNumber } from './helper';
import { phoneNumberQuerySchema, type PhoneNumberQuerySchema } from './phone-number-query-schema';

import { countryQuerySchema } from '../countries';

export const phoneNumberFormSchema = phoneNumberQuerySchema
  .pick({ number: true })
  .extend({
    type: z.object({ name: z.string(), value: z.string() }),
    country: countryQuerySchema,
    isDuplicate: z.boolean(), // .prefault(false),
  })
  .refine(({ type }) => type.value !== '', {
    message: "Type can't be None",
    path: ['type'],
  })
  .refine(
    ({ country, number }) => {
      const { onlyNumberLength, onlyHashLength } = formatPhoneNumber(
        number,
        country.calling_code,
        country.phone_format
      );

      return onlyNumberLength === onlyHashLength;
    },
    {
      message: 'Invalid Phone number',
      path: ['number'],
    }
  )
  .refine(({ isDuplicate }) => !isDuplicate, {
    message: 'This phone number is already added',
    path: ['isDuplicate'],
  });

export type PhoneNumberFormSchema = z.infer<typeof phoneNumberFormSchema>;

export type PhoneNumbersCallback = (t: 'UPDATE' | 'DELETE' | 'CREATE' | 'DELETED', v: PhoneNumberQuerySchema[]) => void;
